export const maxFamilyAccountMembers = 10;

export const AVAILABLE_PATIENT_TYPE = ['Student','Employee','Family Member','Other']

export const WEBSITE_URL = "https://home.aptitudelabs.com";